import { render, staticRenderFns } from "./partTypes.vue?vue&type=template&id=254b9152&"
import script from "./partTypes.vue?vue&type=script&lang=js&"
export * from "./partTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports